// Types
import type { JSX, ReactNode } from 'react';
import type { TTabPosition } from './Tabs.type';

// Helpers
import { checkComponent } from '../../helpers';

// Constants
import { TABS_CHILDREN_DISPLAY_NAME, TABS_POSITION } from './Tab.constant';

// Check if the child is a valid TabList or TabPanel
export const checkTabsChildren = (child: ReactNode | JSX.Element) => {
  let validChild = false;
  TABS_CHILDREN_DISPLAY_NAME.forEach(displayName => {
    if (checkComponent(child, displayName)) {
      validChild = true;
    }
  });

  return validChild;
};

// Calculate the position of the indicator
export const getTabsIndicator = (tabsPosition: TTabPosition, tabRef: HTMLDivElement | null) => {
  switch (tabsPosition) {
    case TABS_POSITION.right: {
      return {
        top: tabRef?.offsetTop
      };
    }
    case TABS_POSITION.bottom: {
      return {
        left: tabRef?.offsetLeft,
        width: tabRef?.offsetWidth
      };
    }
    case TABS_POSITION.left: {
      return {
        top: tabRef?.offsetTop
      };
    }
    default: {
      return {
        left: tabRef?.offsetLeft,
        width: tabRef?.offsetWidth
      };
    }
  }
};
